import { forwardRef } from 'react';
import { View } from 'react-native';

import { twMerge } from 'tailwind-merge';
import TextField, { TextFieldRef } from '../Text/TextField';
import Typography from '../Text/Typography';

export interface TextInputProps {
  value?: string;
  label?: string;
  placeholder?: string;
  onValueChanged?: (value: string) => void;
  onFocus?: () => void;
  onBlur?: () => void;
  readonly?: boolean;
  error?: string;
  className?: string;
}

export let TextInput = forwardRef<TextFieldRef, TextInputProps>(
  (
    {
      value,
      label,
      error,
      placeholder,
      onValueChanged,
      onFocus,
      onBlur,
      readonly,
      className,
    },
    ref
  ) => {
    return (
      <View className="w-full">
        {label && (
          <Typography
            variant="body"
            size="small"
            weight="regular"
            className="text-neutral-400 mb-1"
          >
            {label}
          </Typography>
        )}
        <TextField
          inputMode="text"
          ref={ref}
          fontSize={15}
          fontWeight={400}
          onValueChanged={onValueChanged}
          onFocus={onFocus}
          onBlur={onBlur}
          value={value}
          className={twMerge(
            'w-full text-white h-[44px] bg-neutral-600 items-center rounded-lg flex-row py-3 px-2 focus:border-2 focus:border-prim-electric-blue',
            error != null &&
              'border-2 border-error focus:border-error text-error',
            className
          )}
          placeholder={placeholder ?? label ?? ''}
          readOnly={readonly}
        />
        {error && (
          <Typography
            variant="body"
            size="small"
            weight="regular"
            className="text-error mt-2"
          >
            {error}
          </Typography>
        )}
      </View>
    );
  }
);
